<template>
  <h1 class="logo-title">
    <img
      v-if="theme === 'dark-theme'"
      style="height: 42px"
      src="../../assets/images/logo.png"
      alt=""
    />
    <img
      v-if="theme === 'light-theme'"
      style="height: 42px"
      src="../../assets/images/logo_dark.png"
      alt=""
    />
    <span style="position: relative; bottom: 2px">uesterix</span>
  </h1>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState({
    theme: (state) => state.global.theme,
  }),
};
</script>